module.exports = __webpack_public_path__ + "media/Components/fonts/Niconne-8cf4db57de19f4d203492dab1165a2c0.ttf";